var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "80", height: "79", viewBox: "0 0 80 79", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M78.907 6.06L45.111 39.43l33.796 33.38a3.594 3.594 0 0 1 0 5.04c-1.412 1.36-3.692 1.36-5.105 0L40.056 44.47 6.26 77.85a3.704 3.704 0 0 1-5.105 0 3.545 3.545 0 0 1 0-5.04l33.797-33.38L1.05 6.06a3.545 3.545 0 0 1 0-5.04 3.764 3.764 0 0 1 5.106 0l33.797 33.37L73.751 1.02a3.705 3.705 0 0 1 5.106 0 3.546 3.546 0 0 1 0 5.04h.05z", fill: "#0061AC" })
  );
});